import {
  Background,
  Checkpoint,
  Mediaquery,
  Navigation,
  Swap
  // Tabs
} from 'formstone/jquery';

window.SiteReady(($) => {
  console.log('Init: Main Site');

  let $window = $(window);
  let $body = $('body');

  //

  // Tables

  // $('.page_content').find('table').wrap('<div class="table_wrapper"><div class="table_wrapper_inner"></div></div>');
  $('.wp-block-table').find('table').wrap('<div class="table_wrapper"></div>');

  // Load

  // let windowTimer = null;

  // $window.on('load', () => {
  //   if (typeof windowTimer !== null) {
  //     clearTimeout(windowTimer);
  //   }

  //   windowTimer = setTimeout('window.windowResize', 50);
  // });

  // window.windowResize = () => {
  //   $window.trigger('resize');
  //   $('.js-checkpoint, [data-checkpoint-animation]').checkpoint('resize');
  // };

  // Scroll

  let newScroll = -1;
  let lastScroll = 0;
  let newShift = -1;
  let lastShift = 100;

  function onScroll() {
    newScroll = $window.scrollTop();
    newShift = newScroll;
  }

  function onRAF() {
    if (newScroll != lastScroll) {
      let scrollDir = (newScroll < lastScroll) ? 'up' : 'down';

      if (newScroll > 0) {
        $body.addClass('scrolled');
      } else {
        $body.removeClass('scrolled');
      }

      if (newScroll > 200) {
        if (scrollDir == 'down') {
          if (newShift - lastShift > 80) {
            $body.addClass('shifted');

            lastShift = newShift;
          }
        } else {
          if (lastShift - newShift > 80) {
            $body.removeClass('shifted');

            lastShift = newShift;
          }
        }
      }

      lastScroll = newScroll;
    }

    window.requestAnimationFrame(onRAF);
  }

  $window.on('scroll', onScroll);
  window.requestAnimationFrame(onRAF);

  onScroll();

  // Desktop Nav

  // $('.js-header_menu_handles li, .js-header_menu').on('mouseenter', (e) => {
  //   console.log('mouseenter');
  //   let id = $(e.currentTarget).attr('id')
  //               .replace('menu-item-', '')
  //               .replace('header_menu-', '');
  //   closeMenus();
  //   openMenu(id);
  // }).on('mouseleave', (e) => {
  //   closeMenus();
  // });

  // function openMenu(id) {
  //   let $handle = $('#menu-item-' + id);
  //   let $menu = $('.js-header_menu-' + id);

  //   $handle.addClass('open');
  //   $menu.addClass('open');
  // }

  // function closeMenus() {
  //   $('.js-header_menu_handles li, .js-header_menu').removeClass('open');
  // }

  // function closeMenu(id) {
  //   let $handle = $('#menu-item-' + id);
  //   let $menu = $('.js-header_menu-' + id);

  //   $handle.removeClass('open');
  //   $menu.removeClass('open');
  // }

  // Mobile Nav

  // $('.js-nav_handle').on('activate.swap', () => {
  //   let offset = $('#alert').outerHeight() + 1;

  //   if (newScroll < offset) {
  //     window.scrollToPosition(offset);
  //   }
  // });

  // $body.on('click', (e) => {
  //   if (!$(e.target).closest('.header').length) {
  //     $('.js-nav_handle').swap('deactivate');
  //   }
  // });

  $('.js-mobile_menu .menu > .menu-item-has-children > a').each((index, el) => {
    let $link = $(el);
    let active = ($link.parent('li').hasClass('current-menu-ancestor') || $link.parent('li').hasClass('current_page_item'));
    let html = '';
    let linkClass = 'js-nav_toggle_' + index;

    html += '<span class="toggle_handle js-swap js-nav_toggle';
    if (active) {
      linkClass += ' fs-swap-active';
      html += ' fs-swap-active';
    }
    html += '" data-swap-target=".js-nav_toggle_' + index + '"';
    if (active) {
      html += ' data-swap-active="true"';
    }
    // html += ' data-swap-options="{&quot;maxWidth&quot;:&quot;979px&quot;}"';
    html += '></span>';

    $link.append(html).next('ul').addClass(linkClass);
  });

  $('.js-mobile_menu').on('navigation:open', function() {
    $('.js-mobile_menu').scrollTop(0);
  });

  $body.on('swap:activate', '.js-nav_toggle', (e) => {
    var $to = $(e.currentTarget).parents('li').eq(0);
    let offset = $to.position();
    let margin = parseInt($to.css('scroll-margin-top'), 10);

    if ($('.js-mobile_menu').hasClass('fs-navigation-open')) {
      $('.js-mobile_menu').animate({
        scrollTop: offset.top - margin
      });
    }
  });

  // Filters

  $('.js-filters .js-filter_link').on('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    let $link = $(e.currentTarget);
    let filter = $link.data('filter');
    let value = $link.data('value');

    $('#' + filter).val(value).trigger('change');
  });

  $('.js-filters select').on('change', (e) => {
    $(e.currentTarget).parents('form').submit();
    // let url = $(this).val();
    // window.location.href = url;
  });

  $('.js-jump_link').on('change', (e) => {
    let id = $(e.currentTarget).val();
    let $to = $(id);

    if ($to.length) {
      window.scrollToElement(id);
    }
  });

  // Video Media

  if ($('.js-video_modal, .js-video_swap').length > 0 && $('script[src*="youtube.com/iframe_api"]').length == 0) {
    $('head').append('<script src="//www.youtube.com/iframe_api"></script>');
  }

  let originalYouTubeCallback = window.onYouTubeIframeAPIReady || null; // Fixes background race condition

  window.onYouTubeIframeAPIReady = () => {
    if (typeof originalYouTubeCallback == 'function') {
      originalYouTubeCallback();
    }

    $('.js-video_modal, .js-video_swap').each((index, el) => {
      let $target = $(el);
      let $iframe = $target.find('.js-video_player');
      let src = $iframe.attr('src');

      if (typeof src == 'undefined') {
        $iframe.attr('src', $iframe.data('src'));
      }

      let id = $iframe.attr('id');
      let player = new YT.Player(id, {
        playerVars: {
          'playsinline': 1
        },
        // events: {
        //   'onReady': function(e) {
        //     // e.target.playVideo();
        //   },
        //   // 'onStateChange': onPlayerStateChange
        // }
      });

      $target.data('youtubePlayer', player);
    });
  }

  $('.js-video_modal_close, .js-video_swap_close').on('swap:activate', (e) => {
    let $target = $(e.currentTarget).parents('.js-video_modal, .js-video_swap');
    // let player = $target.data('youtubePlayer');

    $target.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

    // if (typeof player !== 'undefined' && typeof player.playVideo !== 'undefined') {
    //   player.playVideo();

      // var mqState = $.mediaquery('state');
      var windowWidth = window.innerWidth;

      if (windowWidth < 740) {
        document.documentElement.requestFullscreen();
      }
    // }

    // if ($target.hasClass('js-video_modal')) {
    //   $body.append($target);
    // }
  }).on('swap:deactivate', (e) => {
    var $target = $(e.currentTarget).parents('.js-video_modal, .js-video_swap');
    // var player = $target.data('youtubePlayer');

    $target.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');

    // if (typeof player !== 'undefined' && typeof player.pauseVideo !== 'undefined') {
    //   player.pauseVideo();

      if (document.fullscreenElement != null) {
        document.exitFullscreen();
      }
    // }

    // if ($target.hasClass('js-video_modal')) {
    //   $($target.data('video-container')).append($target);
    // }
  });

  // Click-close

  $('.js-swap_modal').on('click', (e) => {
    if ($(e.currentTarget).hasClass('js-swap_modal')) {
      $(e.currentTarget).find('.js-swap').swap('deactivate');
    }
  }).on('swap:activate', (e) => {
    // let $this = $(e.currentTagret);

    // setTimeout(function() {
    //   $this.find('.js-carousel').carousel('reset');
    // }, 170);
  });

  // Brochure Swaps

  // $('.js-brochure_swap').on('swap:activate swap:deactivate', (e) => {

  //   let $currentTarget = $(e.currentTarget);
  //   let $items = $target.parent().children();
  //   let $active = $items.filter('.fs-swap-active');
  //   let $inactive = $items.not('.fs-swap-active');

  //   $items.removeClass('fs-swap-inactive');

  //   if ($active.length > 0) {
  //     $inactive.addClass('fs-swap-inactive');
  //   }
  // });

  // $('.js-brochure_link').on('click', function(e) {
  //   e.stopPropagation();
  // });


  // Plugins

  $('.js-navigation').navigation();
  $('.js-background').background();
  $('.js-swap').swap();
  // $('.js-tabs').tabs();

  $('.js-checkpoint, [data-checkpoint-animation]').checkpoint({
    offset: '100px',
    reverse: true
  });


  // // Gated content

  // function checkGatedContent() {
  //   let post_id = $('.js-gated_target').data('post');

  //   $.ajax({
  //     url: THEME_OPTIONS.ajax_url,
  //     type: 'get',
  //     data: {
  //       action: 'check_gated_content',
  //       post: post_id,
  //     },
  //     success: function(response, status, jqXHR) {
  //       if (response === 'false') {
  //         $('.js-gated_target').addClass('ready');
  //       } else {
  //         $('.js-gated_target').replaceWith(response);
  //       }
  //     },
  //     error: function() {
  //       console.log(arguments);
  //     }
  //   });
  // }

  // if ($('.js-gated_target').length) {
  //   checkGatedContent();

  //   $(document).on('gform_confirmation_loaded', function(e, formId) {
  //     checkGatedContent();
  //   });
  // }


  let $people_grid = $('.js-people');

  $people_grid.each((index, item) => {
    let $people = $(item);
    let $controls = $people.find('.people_control');

    $('.js-people_select').on('change', (e) => {
      let $select = $(e.target);
      let index = $select.val();

      $controls.eq(index - 1).swap('activate');
    });
  });

});

// window.buildMarquees = function($marquees, count) {
//   $marquees.each((index, el) => {
//     let $el = $(el);
//     let $child = $el.find('span');

//     for (let j = 0; j < count; j++) {
//       let $clone = $child.clone();

//       $clone.attr('aria-hidden', 'true');
//       $child.after($clone);
//     }

//     $el.addClass('ready');
//   });
// }